import {dispatchTrackEvent} from "./_tracking";

export default function initQuestions() {
  trackQuestions();
}

function trackQuestions() {
  document.querySelectorAll('.faq details').forEach((question) => {
    question.addEventListener('toggle', (event) => {
      dispatchTrackEvent({
        'eventCategory': 'faq',
        'eventAction': event.target.hasAttribute('open') ? 'open' : 'close',
        'eventLabel': event.target.querySelector('summary').innerText,
        'eventValue': 5,
        'nonInteraction': false,
      }, question);
    });
  });
}
